import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { STATUS_OBJECT } from 'src/app/dummy/status';
import { TESTING_CENTER } from 'src/app/dummy/tab';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { IAppSlide } from 'src/app/interfaces/book-store';
import { AddAppVideoComponent } from '../add-app-video/add-app-video.component';

@Component({
  selector: 'app-app-video',
  templateUrl: './app-video.component.html',
  styleUrls: ['./app-video.component.scss']
})
export class AppVideoComponent implements OnInit {
  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  tabs = TESTING_CENTER.APP_VIDEOS;
  DISPLAY_STATUS_KEY: any;

  constructor(
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    public store: BookstoreStore,
  ) { }

  ngOnInit() {
    this.DISPLAY_STATUS_KEY = STATUS_OBJECT.submitted;
    this.store.fetchData(COLLECTION_NAME.APP_VIDEOS, this.DISPLAY_STATUS_KEY.key)
  }



  create(item?: any) {
    let dialogRef = this.dialog.open(AddAppVideoComponent, {
      data: { ITEM: item || null },
      panelClass: 'item-list-panel',
      width: '',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {
    });
  }


  delete(item: IAppSlide) {
    const dialogRef = this.dialog.open(DeleteComponent, {
      data: {
        title: "Delete Video",
        memo: "Video will permanently drop from app.",
        name: item.name,
        button: "OK",
      },
      panelClass: 'register-test-overlay-panel',
      width: '35vw',
      disableClose: true,
      role: 'dialog'
    });
    dialogRef.afterClosed().subscribe(async result => {
      if (result === 'yes') {
        this.store.deleteItem(COLLECTION_NAME.APP_VIDEOS, item, (success, error) => {
          if (success) {
            this.snackBar.open('Video has been deleted.', 'done', { duration: 2000 });
            this.store.fetchData(COLLECTION_NAME.APP_VIDEOS, this.DISPLAY_STATUS_KEY.key)
          }
          else {
            this.snackBar.open(error, 'Error')
          }
        })
      }
    });
  }

}
